// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilePreviewList_list__YXiMo > :not(:last-child) {
  margin-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/FilePreviewList/FilePreviewList.module.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;AAAJ","sourcesContent":[".list {\n  &>:not(:last-child) {\n    margin-bottom: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `FilePreviewList_list__YXiMo`
};
export default ___CSS_LOADER_EXPORT___;
